export default "__VITE_ASSET__BcxqSKpd__"